import React, { forwardRef, useEffect, useState } from 'react';
import { useForwardedRef, usePrevious } from '@anton.bobrov/react-hooks';
import cn from 'classnames';
import { prefixedClasNames } from '../../utils/prefixedClassNames';
import { FadeContentItem } from './Item';
import { useParentHeight } from './utils/useParentHeight';
export var FadeContent = forwardRef(function (_a, forwardedRef) {
    var className = _a.className, style = _a.style, content = _a.content, activeKey = _a.activeKey, _b = _a.duration, duration = _b === void 0 ? 600 : _b, _c = _a.hasFocus, hasFocus = _c === void 0 ? true : _c;
    var ref = useForwardedRef(forwardedRef);
    var prevActiveKey = usePrevious(activeKey, activeKey);
    var _d = useState(undefined), showKey = _d[0], setShowKey = _d[1];
    var _e = useState(undefined), hideKey = _e[0], setHideKey = _e[1];
    var _f = useState(activeKey), currentKey = _f[0], setCurrentKey = _f[1];
    var getState = function (key) {
        if (key === hideKey) {
            return 'hide';
        }
        if (key === showKey) {
            return 'show';
        }
        if (key === currentKey) {
            return 'active';
        }
        return 'unactive';
    };
    useEffect(function () {
        if (activeKey !== prevActiveKey) {
            setHideKey(prevActiveKey);
        }
    }, [activeKey, prevActiveKey]);
    var parentHeight = useParentHeight(ref);
    return (React.createElement("div", { ref: ref, className: cn(prefixedClasNames('fade-content'), className), style: style, 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0 }, content.map(function (_a) {
        var key = _a.key, children = _a.children;
        var state = getState(key);
        return (React.createElement(FadeContentItem, { key: key, className: cn(prefixedClasNames('fade-content__item'), prefixedClasNames("fade-content__item_".concat(state))), duration: duration / 2, state: state, onShow: function () { var _a; return hasFocus && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true })); }, onShowProgress: function (element, progress) {
                return parentHeight.interpolate(element.getBoundingClientRect().height, progress);
            }, onShown: function () {
                setHideKey(undefined);
                setShowKey(undefined);
                parentHeight.reset();
            }, onHide: function () { return parentHeight.save(); }, onHidden: function () {
                setHideKey(undefined);
                setShowKey(activeKey);
                setCurrentKey(activeKey);
            } }, state !== 'unactive' && children));
    })));
});
FadeContent.displayName = 'FadeContent';
//# sourceMappingURL=index.js.map